import React from 'react';
import { FaStar } from 'react-icons/fa';

const reviews = [
  {
    name: 'Pratik Pagar',
    institution: 'MET Institute of B.Pharmacy',
    rating: 4,
    feedback: 'This internship training is very much helpful for us in future. All teachers are very supportive and understanding of students problems and give solutions to those problems.',
  },
  {
    name: 'Aditya Nagalia',
    institution: 'Graphic Era University, (Mechanical Engineering)',
    rating: 5,
    feedback: 'Digital marketing internship expanded my skills in SEO, social media, and analytics, providing practical insights and a supportive team environment, enhancing both technical and collaborative abilities. Thank you InternsElite for the great opportunity.',
  },
  {
    name: 'Suraj Kumar',
    institution: 'Babu Banarasi Das University, (BBA)',
    rating: 4,
    feedback: 'Thoroughly enjoyed InternsElite\'s digital marketing course. Clear and pleasing teaching style, covering basic concepts to advanced techniques, significantly improving my understanding. Smoother submission processes could enhance the overall experience.',
  },
  {
    name: 'Pranav Shivaji Markad',
    institution: 'IFIM College, (BBA)',
    rating: 5,
    feedback: 'The overall experience of training and internship program was very good. The faculty was very knowledgeable about the particular field. They tried their best to carry out interactive sessions. The assignments given were very helpful.',
  },
  {
    name: 'Nishu Garg',
    institution: 'NMIMS Global, BBA Marketing Management',
    rating: 4,
    feedback: 'Completed a valuable digital marketing training, covering SEO, social media, and analytics. Engaging trainers and hands-on projects boosted my skills and confidence in the dynamic digital landscape. Highly recommend!',
  },
  {
    name: 'Lakshita Baisoya',
    institution: 'Shri Ram College of Commerce',
    rating: 5,
    feedback: 'Overall all the sessions were very interesting and knowledgeable.',
  },
];

function DM_Review_Program_Page() {
  return (
    <div>
      <div>
        <div className='container'>
          <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
              <div className='text-center review_component_text'>
                <h2 className='display-5 pb-2'>Testimonial</h2>
                <p className='fs-6'>
                  Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.
                </p>
              </div>
            </div>
            <div className='col-md-1'></div>
          </div>
          <div className='row'>
            <div className='col-md-4 pt-5'>
              <div className='Program_review_comp'>
                <div className='mt-5 px-5 review_component_text'>
                  <h2 className='pt-5 display-6'>Hear What Our Students Say</h2>
                  <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
                </div>
              </div>
            </div>
            <div className='col-md-8'>
              <div className='row'>
                {reviews.map((review, index) => (
                  <div key={index} className={`col-md-${index % 2 === 0 ? 5 : 7} card`}>
                    <div className='card-body'>
                      <h5 className='font-weight-bold Review_not_copy'>{review.name}</h5>
                      <h6 className='font-weight-bold my-2 Review_not_copy'>{review.institution}</h6>
                      <ul className='list-unstyled d-flex justify-content-start Review_not_copy'>
                        {[...Array(5)].map((_, starIndex) => (
                          <li key={starIndex}>
                            <FaStar color={starIndex < review.rating ? 'gold' : undefined} />
                          </li>
                        ))}
                      </ul>
                      <p className='Review_not_copy'>
                        <i className='fas fa-quote-left pe-2'></i>{review.feedback}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DM_Review_Program_Page;
